import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { authService } from '../../services/authService';
import { useTheme } from '../../context/ThemeContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  const closeMenu = () => setMenuOpen(false);

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  return (
    <header className="navbar">
      <div className="navbar-container">
        <div className="navbar-top">
          <div className="navbar-brand">
            <h1>TradeLab</h1>
            <span className="navbar-subtitle">Strategy Backtesting Platform</span>
          </div>
          <div className="navbar-top-actions">
            <button className="nav-btn theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
              {theme === 'dark' ? '☀️' : '🌙'}
            </button>
            <button className="nav-btn logout-btn" onClick={handleLogout}>
              Logout
            </button>
            <button
              className={`hamburger ${menuOpen ? 'open' : ''}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle navigation"
            >
              <span className="hamburger-line" />
              <span className="hamburger-line" />
              <span className="hamburger-line" />
            </button>
          </div>
        </div>
        <nav className={`navbar-nav ${menuOpen ? 'nav-open' : ''}`}>
          <NavLink to="/" className={({ isActive }) => `nav-btn ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Load Backtest
          </NavLink>
          <NavLink to="/run-backtest" className={({ isActive }) => `nav-btn ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Run Backtest
          </NavLink>
          <NavLink to="/fetch-data" className={({ isActive }) => `nav-btn ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Fetch Data
          </NavLink>
          <NavLink to="/manual-trading" className={({ isActive }) => `nav-btn ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Manual Trading
          </NavLink>
          <NavLink to="/monitor" className={({ isActive }) => `nav-btn ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Monitor
          </NavLink>
          <NavLink to="/historical" className={({ isActive }) => `nav-btn ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Historical
          </NavLink>
          <NavLink to="/advisor" className={({ isActive }) => `nav-btn ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Advisor
          </NavLink>
          <NavLink to="/llm" className={({ isActive }) => `nav-btn ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            LLM
          </NavLink>
          <NavLink to="/analytics" className={({ isActive }) => `nav-btn ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Analytics
          </NavLink>
          <NavLink to="/fund" className={({ isActive }) => `nav-btn ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Fund
          </NavLink>
          <NavLink to="/trading-floor" className={({ isActive }) => `nav-btn ${isActive ? 'active' : ''}`} onClick={closeMenu}>
            Floor
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
